import { render, staticRenderFns } from "./OrderShipmentNotes.vue?vue&type=template&id=017ca77c&"
import script from "./OrderShipmentNotes.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports